












import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'BasePopupSpinner'
})
export default class BasePopupSpinner extends Vue {
}
